import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/countryState/importer/countryStateImporterSelectors';
import CountryStateService from 'src/modules/countryState/countryStateService';
import fields from 'src/modules/countryState/importer/countryStateImporterFields';
import { i18n } from 'src/i18n';

const countryStateImporterActions = importerActions(
  'COUNTRYSTATE_IMPORTER',
  selectors,
  CountryStateService.import,
  fields,
  i18n('entities.countryState.importer.fileName'),
);

export default countryStateImporterActions;